import { render, staticRenderFns } from "./DetailVerify.vue?vue&type=template&id=2c4f9884"
import script from "./DetailVerify.vue?vue&type=script&lang=js"
export * from "./DetailVerify.vue?vue&type=script&lang=js"
import style0 from "./DetailVerify.vue?vue&type=style&index=0&id=2c4f9884&prod&lang=css"
import style1 from "./DetailVerify.vue?vue&type=style&index=1&id=2c4f9884&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports